import secondaryComponents from "../../../../../components/secondaryComponents";
import globalStyles from "../../../../../assets/styles/base/globalPage.module.scss";
import { useAllStorefront } from "./useAllStorefront";
import primaryComponents from "../../../../../components/primaryComponents";
import { pathConstants } from "../../../../../routes/pathContants";
import { useNavigate } from "react-router-dom";
import { PlusIcon, StorefrontLink } from "../../../../../assets/svgIcons";
import {
  StorefrontTable,
  StorefrontTemplateUrl,
} from "../../../../../components/secondaryComponents/storefront";
import { RoutedModal } from "../../../../../components/common";

const AllStorefront = () => {
  const navigate = useNavigate();
  const {
    isLoading,
    storefrontList,
    metaDetails,
    search,
    showAllStorefontsLink,
    setShowAllStorefontsLink,
    gotoPage,
    filterBySearch,
  } = useAllStorefront();

  return (
    <secondaryComponents.MetaSetter
      title="Lumi Merchant | Inventory Storefront"
      description={"View and Manage Storefront"}
    >
      <div className={globalStyles.pageHeaders}>
        <p>{metaDetails?.total} Storefront</p>

        <div className={"d-flex"} style={{ gap: "10px" }}>
          {storefrontList?.[0]?.slug_url ? (
            <>
              <primaryComponents.Button
                classNames="btn btn--outline ml-auto"
                onClick={() => setShowAllStorefontsLink(true)}
              >
                <StorefrontLink />
                <span style={{ fontSize: 15, marginLeft: 2 }}>
                  View Business Storefront
                </span>
              </primaryComponents.Button>
            </>
          ) : null}
          <secondaryComponents.NavigateWithPermission
            permissionParentKey={"Inventory Management"}
            permissionChildKey="can_view_edit_and_create_storefront"
          >
            <primaryComponents.Button
              classNames="btn btn--primary ml-auto"
              onClick={() => navigate(pathConstants.INVENTORY_MENU_CREATE)}
            >
              <PlusIcon className="mr-1" /> Create Storefront
            </primaryComponents.Button>
          </secondaryComponents.NavigateWithPermission>
        </div>
      </div>

      <div className={`${globalStyles.tableWrapper}`}>
        <div className={`${globalStyles.tableHeader}`}>
          <primaryComponents.SearchField
            value={search.get("query") ? search.get("query") : ""}
            placeholder={"Search for a storefront"}
            triggerOnInput={true}
            showsearchBtn={true}
            trigger={(value) => filterBySearch(value)}
            classNames={`${globalStyles.searchField}`}
          />
        </div>

        <secondaryComponents.LoaderHelper
          isLoading={isLoading}
          classNames={"mt-5"}
        >
          <StorefrontTable
            storefrontList={storefrontList}
            metaDetails={metaDetails}
            gotoPage={gotoPage}
          />
        </secondaryComponents.LoaderHelper>
      </div>

      <RoutedModal
        isActive={showAllStorefontsLink}
        width={626}
        headerTitle="All Storefronts Link"
        headerDescription=" Provide a single link for your customers to access all your
          storefronts in one place."
        closeModal={() => setShowAllStorefontsLink(false)}
        style={{ height: "auto" }}
      >
        <StorefrontTemplateUrl storefrontList={storefrontList} />
      </RoutedModal>
    </secondaryComponents.MetaSetter>
  );
};
export default AllStorefront;
